import { useEffect, useRef } from 'react'
import { usePatchCurrentUser } from 'ClientPortal/src/api/Queries/users'
import type { RootUser as User } from '@einwert/valuation-api-client'
import { DEFAULT_LOCALE, getBrowserLocale, SupportedLocale } from 'ClientPortal/src/i18n/supportedLocales'
import { useFetchFeatureFlags } from 'ClientPortal/src/api/Queries/feature-flags'

export function usePersistMissingUserLocale({ user, isUserPending }: { user?: User; isUserPending: boolean }) {
    const { featureFlags, isFeatureFlagsPending } = useFetchFeatureFlags({})
    const { mutate: patchCurrentUser } = usePatchCurrentUser()
    const attemptedLocaleInitializationUserId = useRef<number | undefined>(undefined)

    useEffect(() => {
        if (
            isUserPending ||
            isFeatureFlagsPending ||
            !featureFlags?.enable_localization ||
            user === undefined ||
            user.locale ||
            attemptedLocaleInitializationUserId.current === user.id
        ) {
            return
        }

        const locale: SupportedLocale = getBrowserLocale() ?? DEFAULT_LOCALE
        attemptedLocaleInitializationUserId.current = user.id

        patchCurrentUser({
            operations: [{ op: 'add', path: '/locale', value: locale }],
        })
    }, [featureFlags?.enable_localization, isFeatureFlagsPending, isUserPending, patchCurrentUser, user])
}
